import { render, staticRenderFns } from "./ConfigAlertJira.vue?vue&type=template&id=09517073&"
import script from "./ConfigAlertJira.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertJira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports